var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 519.355,
    height: 322.526,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:5px}.cls-2{stroke-linecap:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147 263c-5.812-.473-10-6-9-17s8-17 17-22 41.362-22.817 45-25c5-3 6-8 0-4s-21 14-29 18-23 14-33 19c-10.198 5.099-23 7-29 0s-9-15 0-27 106.463-84.556 155-103c50-19 25-13 68-25 40.466-11.293 54.769-15.67 67-12 10 3 49 111 49 111s-17 21-21 24-144.997 82.323-164.5 95.5c-37 25-80.076 14.872-45.5-7.5 34-22 38-24 37-26s-8.378 5.982-23 12c-13.403 5.516-42.084 19.05-56 15-6.79-1.976-13-11-4-21s48-30 50-33 2.095-3.844-6 1c-15.696 9.392-49.77 28.484-68 27z",
    transform: "translate(-2.823 -2.516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113 200c-3.473 4.116-35-25-35-25 5-13 63-113 63-113 14 4 25 7 50 0s57-9 74-7 39 4 45 8 27 26 34 38 20 23 18 35-6 15-15 13-23-7-30-13a343.92 343.92 0 01-27-27c-6-7-6.35-9.932-17-7-45.224 12.452-129.75 62.15-160 98z",
    transform: "translate(-2.823 -2.516)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.177 3.484l-83 42 77 142 65-29-59-155zM62.177 3.484l83 42-77 142-65-29 59-155z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 279.68,
    y: 275.5,
    width: 63.64,
    height: 38,
    rx: 19,
    transform: "rotate(45 313.125 289.835)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 307.627,
    y: 246.75,
    width: 74.246,
    height: 38,
    rx: 19,
    transform: "rotate(45 346.375 261.085)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 337.159,
    y: 221,
    width: 87.681,
    height: 38,
    rx: 19,
    transform: "rotate(45 382.625 235.335)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 390.562,
    y: 192.25,
    width: 47.376,
    height: 38,
    rx: 19,
    transform: "rotate(45 415.875 206.585)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationIcon);
export default __webpack_public_path__ + "static/media/consultationIcon.99f7defa98c7f01f21292c0c4a30efd9.svg";
export { ForwardRef as ReactComponent };